import { paymentsLinksViewEnabled } from '@/actions-permission/payment-links.permissions'
import {
  chargebackSearchEnabled,
  chargebackViewEnabled
} from '@/actions-permission/chargeback.permissions'

const SALES = ({
  routeName,
  permissionIsEnabled,
  componentIsEnabled,
  isCheckoutV2Enabled
}) => {
  return {
    key: 'sales',
    label: 'sidemenu.sales',
    showSection:
      permissionIsEnabled('order:search') ||
      permissionIsEnabled('charge:search') ||
      (permissionIsEnabled('trf:search') &&
        componentIsEnabled('sidemenu', 'trf')) ||
      paymentsLinksViewEnabled(permissionIsEnabled, isCheckoutV2Enabled),
    items: {
      orders: {
        label: 'sidemenu.submenu.sales.orders',
        showItem: permissionIsEnabled('order:search'),
        active: routeName === 'orders' || routeName === 'ordersDetail'
      },
      charges: {
        label: 'sidemenu.submenu.sales.charges',
        showItem: permissionIsEnabled('charge:search'),
        active: routeName === 'charges' || routeName === 'chargesDetail'
      },
      trf: {
        label: 'sidemenu.submenu.sales.trf',
        showItem:
          permissionIsEnabled('trf:search') &&
          componentIsEnabled('sidemenu', 'trf'),
        active: routeName === 'trf'
      },
      paymentLinks: {
        label: 'sidemenu.submenu.sales.payment-links',
        showItem: paymentsLinksViewEnabled(
          permissionIsEnabled,
          isCheckoutV2Enabled
        ),
        active:
          routeName === 'payment-links' || routeName === 'payment-links-detail'
      },
      chargebacks: {
        label: 'sidemenu.submenu.sales.chargebacks',
        showItem:
          chargebackSearchEnabled(permissionIsEnabled) ||
          chargebackViewEnabled(permissionIsEnabled),
        active: [
          'chargebacks',
          'chargebackMassRepresentment',
          'chargebackDetails',
          'chargebackRepresentment'
        ].includes(routeName)
      }
    }
  }
}

export default SALES
